<template>
  <vs-popup fullscreen :active.sync="isSidebarActiveLocal" id="halfMadeProductPage"
    :title="Object.entries(data).length === 0 ? 'Yeni Yarı Mamül' : 'Yarı Mamül Düzenle'" v-esc="escape">

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <form data-vv-scope="form-1" @keyup.enter="submitData">
        <vs-row vs-type="flex" vs-w="12" class="px-3">

          <vs-row vs-type="flex" vs-w="12">
            <span class="text-primary text-smaller weight-600 w-full">
              İsim
            </span>
            <vs-input id="name" name="İsim" v-validate="'required|min:2|max:60'" v-model="newHalfMadeProduct.name"
              class="w-full" icon-pack="feather" icon="icon-user" placeholder="İsim" />
            <span class="text-danger text-sm" v-show="errors.has('form-1.İsim')">{{ errors.first('form-1.İsim')}}</span>
          </vs-row>


          <vs-row vs-type="flex" vs-w="12" class="mt-1">
            <span class="text-primary text-smaller weight-600 w-full">
              Birim
            </span>
            <v-select :disabled="units.length == 0" @input="loadAlternateUnitsHalfMade(newHalfMadeProduct.unit.id)"
              id="unit" name="Birim" v-validate="'required'" v-model="newHalfMadeProduct.unit" itemid="id" label="name"
              placeholder="Birim Seçimi.." :options="units" class="w-full" :clearable="true">
            </v-select>
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.Birim')">{{ errors.first('form-1.Birim') }}</span>
          </vs-row>

          <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center" class="mt-1">
            <vs-col vs-type="flex" vs-w="6" class="pr-1">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-primary text-smaller weight-600 w-full">
                  Üretim Miktarı (Reçete Çıktısı)
                </span>
                <vs-input id="minimumOrder" name="Üretim Miktarı" class="w-full"
                  v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
                  v-model="newHalfMadeProduct.minimumOrder" placeholder="Örn: 800" />
                <span class="text-danger text-sm"
                  v-show="errors.has('form-1.Üretim Miktarı')">{{ errors.first("form-1.Üretim Miktarı")}}</span>
              </vs-row>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="pl-1">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-primary text-smaller weight-600 w-full">
                  Sipariş Birimi
                </span>
                <v-select id="orderUnit"
                  :disabled="newHalfMadeProduct.alternateUnits.length == 0 || newHalfMadeProduct.unit == null"
                  name="Sipariş Birimi" v-validate="'required'" class="w-full" v-model="newHalfMadeProduct.orderUnit"
                  itemid="id" label="name" placeholder="Sipariş Birimi Seçimi.."
                  :options="newHalfMadeProduct.alternateUnits" :clearable="false">
                </v-select>
                <span class="text-danger text-sm"
                  v-show="errors.has('form-1.Sipariş Birimi')">{{ errors.first("form-1.Sipariş Birimi") }}</span>
              </vs-row>
            </vs-col>
          </vs-row>

          <vs-textarea id="description" name="Açıklama" v-model="newHalfMadeProduct.description"
            class="w-full mt-1 mb-0" label="Açıklama" />

          <vs-table :data="newHalfMadeProduct.recipeSteps" class="mt-2 w-full">

            <div slot="header" class="w-full flex flex-wrap-reverse items-center flex-grow justify-between">

            </div>
            <template slot="thead">

              <vs-th class="w-2/5">
                Hammadde İsmi
              </vs-th>
              <vs-th class="w-1/4">
                Miktar
              </vs-th>
              <vs-th class="w-1/4">
                Birim
              </vs-th>
              <vs-th class="w-1/4">
                Ara Tutar
              </vs-th>
              <vs-th class="w-1/6">
                İşlem
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td>
                    <v-select :disabled="rawMaterials.length == 0" id="product" name="Hammadde" v-validate="'required'"
                      @input="getAlternateUnits(newHalfMadeProduct.recipeSteps[indextr].rawMaterial,indextr,true)"
                      v-model="newHalfMadeProduct.recipeSteps[indextr].rawMaterial" itemid="id" label="name"
                      placeholder="Hammadde Seçimi.." :options="rawMaterials" :clearable="false"></v-select>
                    <span class="text-danger text-sm"
                      v-show="errors.has('Hammadde')">{{ errors.first('Hammadde')}}</span>
                  </vs-td>

                  <vs-td>
                    <vs-input id="name" :name="(indextr+1) + '.Miktar'"
                      v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
                      v-if="newHalfMadeProduct.recipeSteps[indextr].rawMaterial.name"
                      v-model="newHalfMadeProduct.recipeSteps[indextr].unitPartQuantity" class="w-full" />
                    <span class="text-danger text-sm"
                      v-show="errors.has('form-1.'+(indextr+1) + '.Miktar')">{{ errors.first('form-1.'+(indextr+1) + '.Miktar')}}</span>
                  </vs-td>

                  <vs-td>
                    <v-select id="unit" name="Birim"
                      v-if="newHalfMadeProduct.recipeSteps[indextr].rawMaterial.name && newHalfMadeProduct.recipeSteps[indextr].rawMaterial.alternateUnits"
                      v-model="tr.unit" itemid="id" label="name"
                      placeholder="Birim Seçimi.."
                      :options="tr.rawMaterial.alternateUnits" :clearable="false">
                    </v-select>
                  </vs-td>

                  <vs-td>
                    <p
                      v-if="newHalfMadeProduct.recipeSteps[indextr].unitPartQuantity && newHalfMadeProduct.recipeSteps[indextr].rawMaterial.name && newHalfMadeProduct.recipeSteps[indextr].unit && newHalfMadeProduct.recipeSteps[indextr].rawMaterial.alternateUnits">
                      {{$toCurrency(tr.rawMaterial.buyPrice * tr.unitPartQuantity * tr.unit.originUnitQuantity)}}
                    </p>
                  </vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                      @click.stop="newHalfMadeProduct.recipeSteps.splice(indextr,1)" />
                  </vs-td>

                </vs-tr>
              </tbody>
              <vs-button class="m-4" type="gradient" icon-pack="feather" icon="icon-plus" color="primary"
                @click="newHalfMadeProduct.recipeSteps.push({unit : {},rawMaterial : { alternateUnits : []}})">
              </vs-button>
            </template>
          </vs-table>
          <span class="text-danger text-sm"
            v-show="!newHalfMadeProduct.recipeSteps || (newHalfMadeProduct.recipeSteps.length > 0 && newHalfMadeProduct.recipeSteps[0].rawMaterial == null)">{{"Lütfen Reçete Oluşturunuz."}}</span>
        </vs-row>
      </form>
      <div class="flex mt-5 px-6 pb-4">
        <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
          Vazgeç
        </vs-button>
        <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
      </div>
    </VuePerfectScrollbar>
  </vs-popup>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {
    createNewHalfMadeProduct,
    updateHalfMadeProduct,
  } from '@/api/HalfMadeProduct.js';
  import {
    getRawMaterialListNoGroup,
  } from '@/api/RawMaterial';
  import {
    getUnitNameList,
    getAlternateUnits
  } from '@/api/Unit';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        money: {
          decimal: ".",
          thousands: ",",
          //suffix:" ₺",
          precision: 2
        },
        newHalfMadeProduct: {
          unit:null,
          recipeSteps: [],
          minimumOrder:null,
          alternateUnits:[]
        },
        units: [],
        rawMaterials: [],

        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      }
    },
    methods: {
      loadAlternateUnitsHalfMade(id) {
        getAlternateUnits(id).then(res => {
          if (res && res.status == 200) {
            this.newHalfMadeProduct.alternateUnits = [];
            if(this.newHalfMadeProduct.orderUnit && !res.data.some(x => x.id == this.newHalfMadeProduct.orderUnit.id)) this.newHalfMadeProduct.orderUnit = null;
            this.newHalfMadeProduct.alternateUnits = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Alternatif Birimler Yüklenemedi !"
            });
          }
        }).catch((e) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: e + "Sunucu Bağlantı Hatası !"
          });
        });
      },
      escape() {
        if (this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
      },
      getAlternateUnits: async function (val, index, isNew) {
        let vm = this;
        getAlternateUnits(val.unit.id).then(res => {
          if (res && res.status == 200) {
            let alternateUnits = res.data;
            /*
            for (let i = 0; i < alternateUnits.length; i++) {
              if (i != 0) alternateUnits[i].originUnitQuantity = 1 * (alternateUnits[i].originUnitQuantity || 1) *
                (alternateUnits[i - 1].originUnitQuantity || 1);
              else alternateUnits[i].originUnitQuantity = 1;
            }*/
            val.alternateUnits = _.clone(alternateUnits);
            if (isNew == true) {
              vm.newHalfMadeProduct.recipeSteps[index].unit = val.alternateUnits[0];
            } else vm.newHalfMadeProduct.recipeSteps[index].unit = val.alternateUnits.find(x => x.id == vm
              .newHalfMadeProduct.recipeSteps[index].unit.id);
          } else {
            vm.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Alternatif Birimler Yüklenemedi ! '
            });
          }
        }).catch(() => {
          vm.$vs.notify({
            color: 'danger',
            title: 'Hata ! ',
            text: 'Sunucu Bağlantı Hatası ! '
          });
        });
      },
      getUnits() {
        getUnitNameList().then(res => {
          if (res && res.status == 200) {
            this.units = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata :' + res.status,
              text: 'Birimler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
      },
      getRawMaterialListNoGroup() {
        getRawMaterialListNoGroup().then(res => {
          if (res && res.status == 200) {
            this.rawMaterials = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata :' + res.status,
              text: 'Hammadeler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
      },
      initValues() {
        this.newHalfMadeProduct = {
          unit:null,
          recipeSteps: [],
          minimumOrder:null,
          alternateUnits:[]
        };
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (checker && this.newHalfMadeProduct.recipeSteps != null && this.newHalfMadeProduct.recipeSteps.length >
          0 && (this.newHalfMadeProduct.recipeSteps[0].rawMaterial != null && this.newHalfMadeProduct.recipeSteps[0]
            .rawMaterial.id != null)) {
          //await this.mapNewBranch();
          this.newHalfMadeProduct.minimumOrder = this.newHalfMadeProduct.minimumOrder ? parseFloat(this.newHalfMadeProduct.minimumOrder) : 0;
          this.newHalfMadeProduct.totalBuyPrice = this.newHalfMadeProduct.totalBuyPrice ? parseFloat(this.newHalfMadeProduct.totalBuyPrice) : 0;
          this.newHalfMadeProduct.recipeSteps.forEach(x=> {
            x.unitPartQuantity = x.unitPartQuantity ? parseFloat(x.unitPartQuantity) : null;
            if(x.rawMaterial.alternateUnits && x.rawMaterial.alternateUnits.length > 0)
              x.rawMaterial.alternateUnits.forEach(x=> {
                //x.originUnitQuantity = x.originUnitQuantity ? parseFloat(x.originUnitQuantity) : null;
              })
          })
          if (this.newHalfMadeProduct.id) {
            updateHalfMadeProduct(this.newHalfMadeProduct).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("halfMadeProduct/updateHalfMadeProduct", res.data).then(() => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı',
                    text: 'Yarımamül Güncelleme Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Yarımamül Güncelleme Başarısız !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newHalfMadeProduct.id = 0;
            createNewHalfMadeProduct(this.newHalfMadeProduct).then(res => {
              if (res && res.status == 200) {
                this.$store.dispatch("halfMadeProduct/addHalfMadeProduct", res.data).then(() => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı',
                    text: 'Yarımamül Ekleme Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Yarımamül Ekleme Başarısız !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Yarımamül Ekleme Başarısız !'
              });
            })
          }
        }
      },
    },
    components: {
      VuePerfectScrollbar,
    },
    watch: {
      isSidebarActive: async function (val) {
        if (!val) return
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.data.alternateUnits = [];
          this.newHalfMadeProduct = _.cloneDeep(this.data);
          this.loadAlternateUnitsHalfMade(this.newHalfMadeProduct.unit.id);
          let vm = this;
          this.newHalfMadeProduct.recipeSteps.forEach(async function (item, index) {
            await vm.getAlternateUnits(item.rawMaterial, index, false);
          });
        }
      },
    },
    mounted: function () {
      this.getRawMaterialListNoGroup();
      this.getUnits();
    },
    created: async function () {
      this.$validator.extend('required_Money', {
        getMessage: 'Alış Fiyatı Giriniz.',
        validate: async function (value, field) {
          if (value != '0,00') return true;
          else return false;
        }
      });
    }
  }

</script>

<style>
  #halfMadeProductPage .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: absolute !important;
  }

  #halfMadeProductPage .vs-table .vs__dropdown-menu {
    max-height: 25vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: static !important;
  }

  #halfMadeProductPage .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  #halfMadeProductPage .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

</style>
